export * from "./BetBtnRegular"